export const COMMISSIONING_TYPES = [
  { value: 'commissioning-comm-loop-v2', labelKey: 'commissioning.commLoop', deviceType: 'commLoop' },
  { value: 'commissioning-circuit', labelKey: 'commissioning.circuit', deviceType: 'circuit' },
  { value: 'commissioning-controller', labelKey: 'commissioning.controller', deviceType: 'controller' },
];

export const COMMISSIONING_DEVICE_TYPE_MAP: Record<string, string> = Object.fromEntries(
  COMMISSIONING_TYPES.map(({ value, deviceType }) => [value, deviceType])
);

export const COMMISSIONING_TYPE_LABEL_MAP: Record<string, string> = Object.fromEntries(
  COMMISSIONING_TYPES.map(({ value, labelKey }) => [value, labelKey])
);

export const COMMISSIONING_STATUS_OPTIONS = [
  { value: 'pass', labelKey: 'common.pass' },
  { value: 'pass-with-notes', labelKey: 'common.passWithNotes' },
  { value: 'failed', labelKey: 'common.fail' },
];
